// extracted by mini-css-extract-plugin
var _1 = "PostSortMenuButton-module__animateUploadProgressBarWidth--MdnOy";
var _2 = "PostSortMenuButton-module__animatedBackground--CWfLt";
var _3 = "PostSortMenuButton-module__button--QAljw";
var _4 = "PostSortMenuButton-module__label--PuqBl";
var _5 = "PostSortMenuButton-module__open--MLXSt";
var _6 = "PostSortMenuButton-module__title--m_NQG";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "label", _5 as "open", _6 as "title" }
